import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  bulletinVideos: [],
  success: false,
  error: null,
};

const bulletinVideosReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_BULLETIN_VIDEO_REQUEST:
    case actionTypes.UPDATE_BULLETIN_VIDEO_REQUEST:
    case actionTypes.DELETE_BULLETIN_VIDEO_REQUEST:
    case actionTypes.READ_BULLETIN_VIDEO_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    // SAVE SUCCESS
    case actionTypes.SAVE_BULLETIN_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        bulletinVideos: [...state.bulletinVideos, action.payload],
      };

    // UPDATE SUCCESS
    case actionTypes.UPDATE_BULLETIN_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        bulletinVideos: state.bulletinVideos.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };

    // DELETE SUCCESS
    case actionTypes.DELETE_BULLETIN_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        bulletinVideos: state.bulletinVideos.filter(
          (item) => item._id !== action.payload._id
        ),
      };

    // READ SUCCESS
    case actionTypes.READ_BULLETIN_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        bulletinVideos: action.payload,
      };

    // FAILURES
    case actionTypes.SAVE_BULLETIN_VIDEO_FAILURE:
    case actionTypes.UPDATE_BULLETIN_VIDEO_FAILURE:
    case actionTypes.DELETE_BULLETIN_VIDEO_FAILURE:
    case actionTypes.READ_BULLETIN_VIDEO_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default bulletinVideosReducer;
